export default "__VITE_ASSET__caa581c3__"